import React from 'react';
import { BarChart } from 'modules/barChart';
import { LineChart } from 'modules/lineChart';
import { PieChartWidget } from 'ui/containers/PieChartWidget';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { charts as Charts } from 'ui/views/demo/charts';
 *
 * // render
 * <Charts propName='propValue'/>
 */
export const charts = () => {

    const barData = [
        { name: 'Claim Processing', value: 600, labelText: '600 (18%)' },
        { name: 'Eligibility', value: 502, labelText: '502 (12%)' },
        { name: 'Member Services', value: 935, labelText: '935 (37%)' },
        { name: 'ID Card', value: 918, labelText: '918 (28%)' },
        { name: 'Prior Authorization', value: 427, labelText: '427 (7%)' },
        { name: 'Formulary Inquiry', value: 605, labelText: '605 (18%)' },
        { name: 'Override Request', value: 912, labelText: '912 (28%)' },
        { name: 'Benefits', value: 300, labelText: '300 (6%)' }
    ];

    // const pieData = [
    //     { name: '111 - Open Access Legacy Formulary', value: 400, tooltip: '400 (17%)' },
    //     { name: '222 - Clinical Foxus Formulary', value: 300, tooltip: '300 (27%)' },
    //     { name: '333 - Clinical Outcomes Formulary', value: 300, tooltip: '300 (17%)' },
    //     { name: '444 - Clinical Focus Formulary', value: 278, tooltip: '278 (27%)'},
    //     { name: '555 - Open Access Advantage Formulary', value: 200, tooltip: '200 (11%)' },
    //     { name: '666 - Claim Reimbursement Form', value: 189, tooltip: '189 (12%)'},
    //     { name: '777 - Davita Onboarding Form English', value: 189, tooltip: '189 (15%)' },
    //     { name: '888 - 555 - Open Access Advantage Formulary', value: 200, tooltip: '200 (11%)' },
    //     { name: '999 - Claim Reimbursement Form', value: 189, tooltip: '189 (12%)' },
    // ];

    const pieChartData = [ {
        'name': 'Lithuania',
        'value': 501.9,
        'percentageValue': '10%'
    }, {
        'name': 'Czechia',
        'value': 301.9,
        'percentageValue': '10%'
    }, {
        'name': 'Ireland',
        'value': 201.1,
        'percentageValue': '10%'
    }, {
        'name': 'Germany',
        'value': 165.8,
        'percentageValue': '10%'
    }, {
        'name': 'Australia',
        'value': 139.9,
        'percentageValue': '10%'
    }, {
        'name': 'Austria',
        'value': 128.3,
        'percentageValue': '10%'
    }, {
        'name': 'UK',
        'value': 99,
        'percentageValue': '10%'
    }, {
        'name': 'Lithuania',
        'value': 501.9,
        'percentageValue': '10%'
    }, {
        'name': 'Czechia',
        'value': 301.9,
        'percentageValue': '10%'
    }, {
        'name': 'Ireland',
        'value': 201.1,
        'percentageValue': '10%'
    }
    ];

    const lineData = [
        { name: '02-28', value: 4, tooltip: '400 (17%)' },
        { name: '03-04', value: 8, tooltip: '300 (27%)' },
        { name: '03-11', value: 10, tooltip: '300 (17%)' },
        { name: '03-18', value: 2, tooltip: '278 (27%)' },
        { name: '03-25', value: 4, tooltip: '200 (11%)' },
        { name: '04-01', value: 13, tooltip: '189 (12%)' },
        { name: '04-01', value: 6, tooltip: '189 (15%)' },
        { name: '04-08', value: 12, tooltip: '189 (22%)' }
    ];

    return (
        <div className='ui-charts'>
            <BarChart data = { barData } className='ui-charts__chart'/>
            <PieChartWidget data={ pieChartData }/>
            {/* <PieChart data = { pieData } className='ui-charts__chart' colorConfig={ ColorConfig }/> */}
            <LineChart data = { lineData } className='ui-charts__chart'/>
        </div>
    );
};

// set display name
charts.displayName = 'charts';

// set default props
charts.defaultProps = {};

// prop types
charts.propTypes = {};
